import api from '../index'
import { extendApiSlice } from '../tags/getTagsMetadata'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    // deprecated mutation
    getMetaFilters: builder.mutation({
      query: body => ({ url: '/api/meta/filters', method: 'POST', body }),
    }),
    fetchMetaFilters: builder.query({
      query: ({ body = undefined, params = undefined }) => ({
        url: '/api/meta/filters',
        method: 'POST',
        body: {
          ...body,
        },
        params,
      }),
    }),
    fetchAllMetaFilters: builder.query({
      query: () => ({ url: '/api/meta/filters', method: 'POST', body: {} }),
    }),
  }),
})

export const {
  useGetMetaFiltersMutation,
  useLazyFetchMetaFiltersQuery,
  useFetchMetaFiltersQuery,
  useFetchAllMetaFiltersQuery,
  useLazyFetchAllMetaFiltersQuery,
} = extendedApi

export const selectMetaFilters = extendApiSlice.endpoints.fetchAllMetaFilters.select()
